export default function backgroundPosition({ width, height, conventional, previousBackgroundPosition, previousBackgroundSize, nextBackgroundSize }) {
  const { backgroundPositionX, backgroundPositionY } = previousBackgroundPosition

  const centerX = backgroundPositionX - width / 2
  const centerY = backgroundPositionY - height / 2

  const scale = previousBackgroundSize ? nextBackgroundSize.backgroundSizeX / previousBackgroundSize.backgroundSizeX : 1

  return {
    backgroundPositionX: centerX * scale + width / 2,
    backgroundPositionY: centerY * scale + height / 2
  }
}



// WEBPACK FOOTER //
// ./src/helpers/fovPreview/backgroundPosition.js